import React from 'react';
import { AuthBannerReactivateForBenefits } from './AuthBannerReactivateForBenefits';
import { AuthBannerDefault } from './AuthBannerDefault';
import {
  OFFER_REACTIVATE_FOR_ANNUAL_DISCOUNT,
  OFFER_REACTIVATE_FOR_BENEFITS,
} from '../../../billing/types';
import { AuthBannerReactivateForAnnualDiscount } from './AuthBannerReactivateForAnnualDiscount';

export const AuthBannerSwitcher = (props: { offer?: string }) => {
  switch (props.offer) {
    case OFFER_REACTIVATE_FOR_BENEFITS:
      return <AuthBannerReactivateForBenefits />;
    case OFFER_REACTIVATE_FOR_ANNUAL_DISCOUNT:
      return <AuthBannerReactivateForAnnualDiscount />;
    default:
      return <AuthBannerDefault />;
  }
};
